import type { GroundingSource } from '@rp/contracts'
import { Button, Chip, Choice, ConfidenceMeter } from '../../design'
import { SUGGESTION_COPY } from './copy'

export type GroundingSelection = {
  selectedIds: readonly string[]
  adoptingId: string | null
  canAdopt: boolean
  onToggle: (id: string) => void
  onAdopt: (id: string) => void
}

type GroundingListProps = {
  sources: readonly GroundingSource[]
  selection?: GroundingSelection | undefined
}

type SourceRowProps = { source: GroundingSource; selection?: GroundingSelection | undefined }

const SourceRow = ({ source, selection }: SourceRowProps) => (
  <li className="grounding-source">
    <div className="grounding-head">
      {selection === undefined ? null : (
        <Choice
          type="checkbox"
          name="grounding-selection"
          value={source.id}
          checked={selection.selectedIds.includes(source.id)}
          onChange={selection.onToggle}
          label={source.title}
        />
      )}
      <Chip tone="info">{SUGGESTION_COPY.sourceKinds[source.kind]}</Chip>
      {selection === undefined ? <span className="grounding-title">{source.title}</span> : null}
      <ConfidenceMeter value={source.similarity} label={SUGGESTION_COPY.similarityLabel} />
    </div>
    <p className="grounding-excerpt">{source.excerpt}</p>
    {selection === undefined ? null : (
      <Button
        className="grounding-adopt"
        variant="ghost"
        disabled={!selection.canAdopt || selection.adoptingId !== null}
        pending={selection.adoptingId === source.id}
        pendingLabel={SUGGESTION_COPY.adopting}
        onClick={() => selection.onAdopt(source.id)}
      >
        {SUGGESTION_COPY.adopt}
      </Button>
    )}
  </li>
)

export const GroundingList = ({ sources, selection }: GroundingListProps) => {
  if (sources.length === 0) return null
  return (
    <section className="grounding">
      <h3 className="grounding-label">
        <span>{SUGGESTION_COPY.grounding}</span>
        <span className="grounding-count num">{sources.length}</span>
      </h3>
      {selection === undefined ? null : <p className="grounding-hint">{SUGGESTION_COPY.groundingHint}</p>}
      <ul className="grounding-list" aria-label={SUGGESTION_COPY.grounding}>
        {sources.map((source) => (
          <SourceRow key={source.id} source={source} selection={selection} />
        ))}
      </ul>
    </section>
  )
}
